import Navigation from './Navigation';
import Breakpoints from './Breakpoints';

const components = {
  menu: '#term-navigation-menu',
  button: '.block-title button',
  buttonLink: '.block-title a',
};

const settings = {
  menuBlock: 'term-navigation',
  menuParent: 'li.collapsed, li.expanded',
  expandActiveMenus: true,
  closeUnnestedMenus: false,
  focusout: false,
  hover: false,
};

export default class TermNavigation {
  constructor(element) {
    this.element = element;
    this.open = false;

    if (this.menu) {
      this.standardize();
      this.addLogic();
      this.listen();
    }

    this.ready();
  }

  // Add depth classes to our term navigation structure which match the primary
  // navigation. That way we can share styling more easily.
  standardize() {
    this.menu.querySelectorAll('a.menu-link').forEach((link) => {
      const match = link.getAttribute('class').match(/depth-([0-9]+)/);
      if (match) {
        const level = match[1];
        // Replace current class with new depth to retain structure.
        link.classList.remove(`depth-${level}`);
        link.classList.add(`depth-${level - 1}`);
        // Add the appropriate classes to the list and it's items.
        const item = link.parentElement;
        const list = item.parentElement;
        item.classList.add(`depth-${level - 1}`);
        list.classList.add(`depth-${level - 1}`);
      }
    });
  }

  // Enhance the term navigation with the standardized, accessible, menu.
  addLogic() {
    return new Navigation(this.menu, settings);
  }

  // We want to control the mobile dropdown but let the desktop link go thru.
  clickHandler() {
    if (Breakpoints.mobileState) {
      if (this.open) {
        this.open = false;
        this.button.setAttribute('aria-expanded', false);
        this.element.classList.remove('term-navigation--open');
        this.menu.setAttribute('aria-hidden', true);
      } else {
        this.open = true;
        this.button.setAttribute('aria-expanded', true);
        this.element.classList.add('term-navigation--open');
        this.menu.setAttribute('aria-hidden', false);
        this.buttonLink.focus();
      }
    }
  }

  listen() {
    // Add a click handler to control the mobile dropdown menu
    this.button.addEventListener('click', this.clickHandler.bind(this));
  }

  ready() {
    this.element.classList.add('ready');
  }

  get button() {
    return this.element.querySelector(components.button);
  }

  get buttonLink() {
    return this.element.querySelector(components.buttonLink);
  }

  get menu() {
    return this.element.querySelector(components.menu);
  }
}
